<template>
    <div class="error-container">
      <h2>Error 404 - Esta página no existe</h2>
      <p>Gogo no tiene idea de a dónde carajo quieres llegar.</p>
      <img src="@/assets/gogonator.jpg" alt="Revisa la URL pndj" class="error-image" />
    </div>
    <AdSense />
  </template>
  
  <script>
  import AdSense from './AdSense.vue';
  export default {
    components: {
      AdSense
    }
  };
  </script>
  
  <style>
  /* Agrega aquí los estilos específicos */
  </style>
  